module.exports = __webpack_public_path__ + "img/enseption_01.21d4da39.png";